
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice",
      function () {
        return require("private-next-pages/practice/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice"])
      });
    }
  